import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"


export default function AppInTerminalAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		label="In Terminal"
		placeholder="Any option"
		{...props}
	/>
}